<!--
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2023-01-03 00:23:07
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-01-04 11:04:55
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/tail/components/videoComp.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
    视频模块
-->
<template>
  <div class="video">
    <div id="video">
      <video
        ref="videoComp"
        data-v-3b1260f5=""
        id="vido_one"
        :src="src"
        controls="controls"
        webkit-playsinline=""
        :poster="poster"
        playsinline=""
        :muted="muted"
        x5-video-player-type="h5"
        class="video__player poster"
      >
        抱歉，您的浏览器不支持内嵌视频
      </video>
    </div>
  </div>
</template>
<script>
export default {
  props: ['src', 'poster'],
  data() {
    return {
      muted: false,
    };
  },
  methods: {
    play() {
      this.$refs.videoComp.play();
      this.muted = true;
    },
  },
};
</script>
<style lang="less" scoped>
.video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 30px);
  margin: 0 auto;
  &-tit {
    width: calc(100% - 94px);
    padding-top: 40px;
    margin-left: auto;
    margin-right: auto;
  }
  video {
    width: 100%;
    height: 200px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>